import { render, staticRenderFns } from "./CardBadges.vue?vue&type=template&id=2c58b32c&scoped=true&"
import script from "./CardBadges.vue?vue&type=script&lang=js&"
export * from "./CardBadges.vue?vue&type=script&lang=js&"
import style0 from "./CardBadges.vue?vue&type=style&index=0&id=2c58b32c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58b32c",
  null
  
)

export default component.exports